namespace GeniuzPOS.Customer {
    export interface Report_1106CustomerForm {
        CustCode: Serenity.StringEditor;
        CustGroupCode: Serenity.LookupEditor;
        CustName: Serenity.StringEditor;
        ContactName: Serenity.StringEditor;
        CusTel: Serenity.StringEditor;
        Email: Serenity.StringEditor;
        CusRemark: Serenity.TextAreaEditor;
        Address: Serenity.StringEditor;
        Tumbol: Serenity.StringEditor;
        Amphur: Serenity.StringEditor;
        Province: Serenity.StringEditor;
        ZipCode: Serenity.StringEditor;
        Country: Serenity.StringEditor;
        CustRegName: Serenity.StringEditor;
        CustTaxId: Serenity.StringEditor;
        CustRegAddress: Serenity.StringEditor;
        CustRegTumbol: Serenity.StringEditor;
        CustRegAmphur: Serenity.StringEditor;
        CustRegProvince: Serenity.StringEditor;
        CustRegZipCode: Serenity.StringEditor;
        CustRegCountry: Serenity.StringEditor;
        CustRegAdd1: Serenity.StringEditor;
        CustRegAdd2: Serenity.StringEditor;
        CustRegAdd3: Serenity.StringEditor;
        ShipName: Serenity.StringEditor;
        ShipAddress: Serenity.StringEditor;
        ShipTumbol: Serenity.StringEditor;
        ShipAmphur: Serenity.StringEditor;
        ShipProvince: Serenity.StringEditor;
        ShipZipCode: Serenity.StringEditor;
        ShipCountry: Serenity.StringEditor;
        ShipAddLine1: Serenity.StringEditor;
        ShipAddLine2: Serenity.StringEditor;
        ShipAddLine3: Serenity.StringEditor;
        SalesmanId: Serenity.LookupEditor;
        SaleMemo: Serenity.TextAreaEditor;
    }

    export class Report_1106CustomerForm extends Serenity.PrefixedContext {
        static formKey = 'Customer.Report_1106Customer';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!Report_1106CustomerForm.init)  {
                Report_1106CustomerForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.TextAreaEditor;

                Q.initFormType(Report_1106CustomerForm, [
                    'CustCode', w0,
                    'CustGroupCode', w1,
                    'CustName', w0,
                    'ContactName', w0,
                    'CusTel', w0,
                    'Email', w0,
                    'CusRemark', w2,
                    'Address', w0,
                    'Tumbol', w0,
                    'Amphur', w0,
                    'Province', w0,
                    'ZipCode', w0,
                    'Country', w0,
                    'CustRegName', w0,
                    'CustTaxId', w0,
                    'CustRegAddress', w0,
                    'CustRegTumbol', w0,
                    'CustRegAmphur', w0,
                    'CustRegProvince', w0,
                    'CustRegZipCode', w0,
                    'CustRegCountry', w0,
                    'CustRegAdd1', w0,
                    'CustRegAdd2', w0,
                    'CustRegAdd3', w0,
                    'ShipName', w0,
                    'ShipAddress', w0,
                    'ShipTumbol', w0,
                    'ShipAmphur', w0,
                    'ShipProvince', w0,
                    'ShipZipCode', w0,
                    'ShipCountry', w0,
                    'ShipAddLine1', w0,
                    'ShipAddLine2', w0,
                    'ShipAddLine3', w0,
                    'SalesmanId', w1,
                    'SaleMemo', w2
                ]);
            }
        }
    }
}
